import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7befb4e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  itemprop: "contactPoint",
  class: "contact"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "contact-header" }, "Contact", -1))
const _hoisted_3 = {
  target: "_blank",
  class: "icon-wrapper icon-email",
  tabindex: "0",
  href: "mailto:bento-miguel@outlook.com",
  itemprop: "email"
}
const _hoisted_4 = {
  target: "_blank",
  class: "icon-wrapper icon-github",
  tabindex: "0",
  href: "https://github.com/Miguel-Bento-Github",
  itemprop: "url"
}
const _hoisted_5 = {
  target: "_blank",
  class: "icon-wrapper icon-linked",
  tabindex: "0",
  href: "https://www.linkedin.com/in/miguel-angelo-bento/",
  itemprop: "url"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_email = _resolveComponent("icon-email")!
  const _component_icon_github = _resolveComponent("icon-github")!
  const _component_icon_linked = _resolveComponent("icon-linked")!

  return (_openBlock(), _createElementBlock("address", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("a", _hoisted_3, [
      _createVNode(_component_icon_email, {
        class: "icon",
        "aria-label": "email icon"
      })
    ]),
    _createElementVNode("a", _hoisted_4, [
      _createVNode(_component_icon_github, {
        class: "icon",
        "aria-label": "github icon"
      })
    ]),
    _createElementVNode("a", _hoisted_5, [
      _createVNode(_component_icon_linked, {
        class: "icon",
        "aria-label": "linkedIn icon"
      })
    ])
  ]))
}